import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import networks from '../../../test/networks'


const initialState = []
// const initialState = networks


export default function appReducer(state = initialState, action) {
  // console.log("----action----", action)
  switch (action.type) {
    case types.ADD_NETWORK: {
      return [
        ...state,
        action.payload
      ]
    }

    case types.EDIT_NETWORK: {
      return [...state.map(network => network.id == action.payload.id ? (action.payload) : ({ ...network }))]
    }

    case types.DELETE_NETWORK: {
      return state.filter(network => network.id !== action.payload.id)
    }

    case types.UPDATE_FULL_NETWORKS: {
      return [
        ...state,
        ...action.payload
      ]
    }

    case types.RESET_NETWORKS: {
      return [
        ...action.payload
      ]
    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);

    default:
      return state;
  }
}